import { Field, FormikProps, useFormikContext } from 'formik'
import React, { FC, useState } from 'react'
import { autocompleteDTO } from './autocompleteDTO'
import { ErrorMessageInput } from './ErrorMessageInput'
import { TypeHeadInout } from './TypeheadInput'
import { Button } from '../../utils/Button'
import { IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import DropdownTreeSelect from 'react-dropdown-tree-select'
import { SketchPicker, Color, ColorResult } from 'react-color'

const FormGroupInput: FC<propsInterfaceFormGroupInput> = (props) => {
  const { values, validateForm, touched, errors, setFieldValue } = useFormikContext<any>()
  let hide: React.CSSProperties = { display: '' }
  let mb2: React.CSSProperties = { marginBottom: '2px' }
  let msgBorder: React.CSSProperties = { border: 'solid 1px #28295E !important' }
  if (props.hideInput) {
    hide = { display: 'none' }
  }
  const resetTreeData = (treeData: any) => {
    treeData.map((fater: any) => {
      fater?.children.map((child: any) => {
        child.checked = false;
        child?.children?.map((child2: any) => {
          child2.checked = false;
          child2?.children?.map((child3: any) => {
            child3.checked = false;
          })
        })
      })
    })
  }
  let columnInput = ''
  if (props.columInput === 1) columnInput = 'col-12'
  else if (props.columInput === 2) columnInput = 'col-xs-12 col-md-6 col-lg-6'
  else if (props.columInput === 3) columnInput = 'col-xs-12 col-md-4 col-lg-4'
  else if (props.columInput === 4) columnInput = 'col-xs-12 col-md-3 col-lg-3'
  else if (props.columInput === 5) columnInput = 'col-xs-12 col-md-4 col-lg-2'
  else if (props.columInput === 6) columnInput = 'col-xs-12 col-md-4 col-lg-1'
  else columnInput = 'col-xs-12 col-md-6 col-lg-6'
  if (props.type === 'autocomplete') {
    let clase = props.className + ' b-0 p-0 m-0'
    return (
      <div style={hide} className={columnInput}>
        {props.label ? (
          <p><label
            htmlFor={props.campo}
            onClick={() => {
              return props.onClickLabel
                ? props?.onClickLabel(props, setFieldValue, values, props.arrayInput)
                : null
            }}
            className='d-flex align-items-center form-label fw-b'
          >
            <div style={props?.onClickLabel ? { width: "100%", cursor: "pointer" } : undefined}>
              {props.label}
              {props?.onClickLabel ? <i className="bi bi-search float-right" style={{ float: "right" }} ></i> : null}
            </div>
          </label></p>
        ) : null}
        <TypeHeadInout
          campo={props.campo}
          clase={clase}
          advanceOptions={props.advanceOptions}
          style={props.style}
          disabled={props.disabled}
          onChange={(e) => {
            return props.onChange
              ? props.onChange(e, setFieldValue, values, props.arrayInput, props)
              : null
          }}
        />
        {touched[props.campo] && errors[props.campo] ? (
          <ErrorMessageInput message={errors[props.campo]?.toString()!} />
        ) : null}
      </div>
    )
  } else if (props.type === 'color') {
    return (
      <div style={hide} className={columnInput}>
        {props.label ? (
          <p><label htmlFor={props.campo} className='d-flex align-items-center form-label fw-b'>
            {props.label}
          </label></p>
        ) : null}
        <SketchPicker
          color={props.color}
          onChange={(color: Color | ColorResult, e: any) => {
            return props.onChangeColor
              ? props.onChangeColor(
                color,
                e,
                setFieldValue,
                values,
                props.arrayInput,
              )
              : null
          }}
        />
        {touched[props.campo] && errors[props.campo] ? (
          <ErrorMessageInput message={errors[props.campo]?.toString()!} />
        ) : null}
      </div>
    )
  } else if (props.type === 'file') {
    return (
      <div style={hide} className={columnInput}>
        <p><label className='d-flex align-items-center form-label' htmlFor={props.campo}>
          {props.label}
        </label></p>
        <div className='d-flex'>
          <input
            id='file-input-data'
            ref={props.fileRef}
            className='form-control border-1 bg-primary'
            type='file'
            name='file-input-data'
            onChange={(e: any) => {
              return props.onChangeFile
                ? props.onChangeFile(
                  e,
                  setFieldValue,
                  values,
                  props.arrayInput,
                )
                : null
            }}
          />
          <IconButton
            aria-label="Clear"
            color='inherit'
            onClick={() => {
              return props.onClearFile ? props.onClearFile(setFieldValue, values, props.arrayInput) : null
            }}
          >
            <ClearIcon />
          </IconButton>
        </div>
        {touched[props.campo] && errors[props.campo] ? (
          <ErrorMessageInput message={errors[props.campo]?.toString()!} />
        ) : null}
      </div>
    )
  } else if (props.type === 'date' || props.type === 'month') {
    return (
      <div style={hide} className={columnInput}>
        {props.label ? (
          <p><label htmlFor={props.campo} className='d-flex align-items-center form-label fw-b'>
            {props.label}
          </label></p>
        ) : null}
        <input
          min={props.min}
          max={props.max}
          type={props.type}
          name={props.campo}
          className={props.className}
          placeholder={props.placeholder}
          style={props.style}
          id={props.id}
          readOnly={props.readonly}
          disabled={props.disabled}
          defaultValue={values[props.campo]}
          onWheel={(e: any) => e.target.blur()}
          onChange={(e) => {
            const date = new Date(e.currentTarget.value + 'T00:00:00')
            values[props.campo] = date
            validateForm()
            return props.onChange
              ? props.onChange(e, setFieldValue, values, props.arrayInput,props)
              : null
          }}
        />
        {touched[props.campo] && errors[props.campo] ? (
          <ErrorMessageInput message={errors[props.campo]?.toString()!} />
        ) : null}
      </div>
    )
  } else if (props.type === 'select-checkbox') {
    let clase = props.className + ' b-0 p-0 m-0'
    return (
      <div style={hide} className={columnInput}>
        <p><label className='d-flex align-items-center form-label' htmlFor={props.campo}>
          {props.label}
        </label></p>
        <div className='input-group'>
          <div className='input-group-prepend'>
            <div className='input-group-text content-icon-day'>
              <Field
                name={props.campoChk}
                className={`form-check-input icon-day ${(props.disabled || props.readonlyCheckbox) ? 'checkbox-disabled-no-check' : ''}`}
                onClick={() => {
                  // Si está disabled o readonlyCheckbox, no permitir cambios
                  if (props.disabled || props.readonlyCheckbox) {
                    return
                  }
                  
                  if (props.campoChk) {
                    values[props.campoChk] = !values[props.campoChk]
                    if (!values[props.campoChk]) values[props.campo] = 0
                  }

                  return props.onClick
                    ? props.onClick(props, setFieldValue, values, props.arrayInput)
                    : null
                }}
                type='checkbox'
                aria-label={props.label}
                readOnly={props.readonly || props.readonlyCheckbox}
                disabled={props.disabled || props.readonlyCheckbox}
                checked={(props.disabled || props.readonlyCheckbox) ? false : undefined}
              />
            </div>
          </div>

          <div style={hide} className='w-75'>
            <TypeHeadInout
              campo={props.campo}
              clase={clase}
              advanceOptions={props.advanceOptions}
              style={props.style}
              disabled={props.campoChk && values[props.campoChk] !== true ? true : props.disabled}
              onChange={(e) => {
                return props.onChange
                  ? props.onChange(e, setFieldValue, values, props.arrayInput, props)
                  : null
              }}
            />
            {touched[props.campo] && errors[props.campo] ? (
              <ErrorMessageInput message={errors[props.campo]?.toString()!} />
            ) : null}
          </div>
        </div>
      </div>
    )
  } else if (props.type === 'number-checkbox') {
    return (
      <div style={hide} className={columnInput}>
        <p><label className='d-flex align-items-center form-label' htmlFor={props.campo}>
          {props.label}
        </label></p>
        <div className='input-group'>
          <div className='input-group-prepend'>
            <div className='input-group-text content-icon-day'>
              <Field
                name={props.campoChk}
                className='form-check-input icon-day'
                onClick={() => {
                  if (props.campoChk) {
                    values[props.campoChk] = !values[props.campoChk]
                    if (!values[props.campoChk]) values[props.campo] = 0
                  }

                  return props.onClick
                    ? props.onClick(props, setFieldValue, values, props.arrayInput)
                    : null
                }}
                type='checkbox'
                aria-label={props.label}
                readOnly={props.readonly || props.readonlyCheckbox}
                disabled={props.disabled || props.readonlyCheckbox}
              />
            </div>
          </div>
          <Field
            type='number'
            name={props.campo}
            className={props.className}
            id={props.campo}
            style={props.style}
            readOnly={props.readonly}
            disabled={props.campoChk && !values[props?.campoChk]}
            placeholder={props.placeholder}
            onWheel={(e: any) => e.target.blur()}
            onBlur={(e: any) => {
              return props.onBlur ? props.onBlur(e, setFieldValue, values, props.arrayInput) : null
            }}
            aria-label={props.label}
          />
          {touched[props.campo] && errors[props.campo] ? (
            <ErrorMessageInput message={errors[props.campo]?.toString()!} />
          ) : null}
        </div>
      </div>
    )
  } else if (props.type === 'button') {
    return (
      <div style={hide} className={columnInput}>
        {/* <label className="d-flex align-items-center form-label" htmlFor={props.campo}>{props.label}</label> */}
        <div className='input-group'>
          <Button
            className={props.className}
            type='button'
            onClick={() => {
              return props.onClick
                ? props.onClick(props, setFieldValue, values, props.arrayInput)
                : null
            }}
          >
            {props.label}
          </Button>
        </div>
      </div>
    )
  } else if (props.type === 'tree-select') {
    if (values[props.campo].length > 0) {
      if (values[props.campo][0].text !== "") {
        props?.treeData?.map((item: any) => {
          if (JSON.stringify(item.label).indexOf(values[props.campo][0].text)) {
            item.children?.map((child: any) => {
              if (JSON.stringify(child.label).indexOf(values[props.campo][0].text)) {
                if (child.value == values[props.campo][0].value) {
                  child.checked = true;
                } else {
                  child.children?.map((child2: any) => {
                    if (JSON.stringify(child2.label).indexOf(values[props.campo][0].text)) {
                      if (child2.children) {
                        child2.children?.map((child3: any) => {
                          if (JSON.stringify(child3.label).indexOf(values[props.campo][0].text)) {
                            if (child3.value == values[props.campo][0].value) {
                              child3.checked = true
                            }
                          }
                        })
                      } else {
                        if (child2.value == values[props.campo][0].value) {
                          child2.checked = true
                        }
                      }
                    }
                  })
                }
              }
            })
          }
        })
      } else {
        resetTreeData(props?.treeData);
      }
    } else {
      resetTreeData(props?.treeData);
    }
    return (
      <div style={hide} className={columnInput}>
        <p><label className='d-flex align-items-center form-label' htmlFor={props.campo}>
          {props.label}
        </label></p>
        <div className='input-group' style={mb2}>
          <DropdownTreeSelect
            data={props.treeData || []}
            onChange={(currentNode, selectedNodes) => {
              if (currentNode.checked) {
                values[props.campo] = [
                  {
                    text: currentNode.label, value: currentNode.value.toString(), tagLabel: currentNode.tagLabel, title: currentNode.tagLabel
                  },
                ]
                // setFieldValue(props.campo, [{ text: currentNode.label, value: currentNode.value.toString() }])
              } else {
                values[props.campo] = []
                // setFieldValue(props.campo, [{ text: currentNode.label, value: currentNode.value.toString() }])
              }

              return props.onChangeTree
                ? props.onChangeTree(
                  setFieldValue,
                  values,
                  props.arrayInput,
                  currentNode,
                  selectedNodes
                )
                : null
            }}
            className={props.className}
            mode='radioSelect'
            keepTreeOnSearch={true}
            keepOpenOnSelect={false}
          />
        </div>
      </div>
    )
  }
  else {
    let as = props.type === 'textarea' ? 'textarea' : ''
    return (
      <div
        style={hide}
        className={
          props.type === 'checkbox'
            ? props.isSwitch
              ? 'form-check form-switch ' + columnInput
              : 'form-check ' + columnInput
            : columnInput
        }
      >
        {props.type !== 'checkbox' && props.type !== 'radio' ? (
          props.label ? (
            <p><label htmlFor={props.campo} className='d-flex align-items-center form-label'>
              {props.label}
            </label></p>
          ) : null
        ) : null}
        <Field
          name={props.campo}
          type={props.type}
          placeholder={props.placeholder}
          as={as}
          id={props.id || props.campo}
          style={msgBorder}
          className={(props.type === 'textarea' ? ' text-area-input' : props.className)}
          rows={props.rows}
          cols={props.cols}
          maxLength={props.maxLength}
          onWheel={(e: any) => e.target.blur()}
          onBlur={(e: any) => {
            return props.onBlur ? props.onBlur(e, setFieldValue, values, props.arrayInput) : null
          }}
          onClick={() => {
            return props.onClick
              ? props.onClick(props, setFieldValue, values, props.arrayInput)
              : null
          }}
          onInput={(e: any) => {
            return props.onInput ? props.onInput(e, setFieldValue, values, props.arrayInput) : null
          }}
          onKeyUp={(e: any) => {
            return props.onKeyUp ? props.onKeyUp(e, setFieldValue, values, props.arrayInput) : null
          }}
          readOnly={props.readonly}
          disabled={props.disabled}
        ></Field>
        {props.type === 'textarea' && props.maxLength ? (
          <p>({values[props.campo].length + ' / ' + props.maxLength})</p>
        ) : null}
        {props.type === 'radio' || props.type === 'checkbox' ? (
          props.label ? (
            <p><label htmlFor={props.campo} className='d-flex align-items-center form-label'>
              {props.label}
            </label></p>
          ) : null
        ) : null}
        {touched[props.campo] && errors[props.campo] ? (
          <ErrorMessageInput message={errors[props.campo]?.toString()!} />
        ) : null}
      </div>
    )
  }
}
FormGroupInput.defaultProps = {
  type: 'text',
  className: 'form-control',
  columInput: 2,
  hideInput: false,
  readonly: false,
  readonlyCheckbox: false,
  disabled: false,
}
export interface propsInterfaceFormGroupInput {
  label?: React.ReactNode
  id?: string
  campo: string
  campoChk?: string
  placeholder?: string
  treeData?: any
  fileRef?: any
  type:
  | 'text'
  | 'number'
  | 'file'
  | 'checkbox'
  | 'radio'
  | 'date'
  | 'textarea'
  | 'autocomplete'
  | 'select-checkbox'
  | 'number-checkbox'
  | 'button'
  | 'tree-select'
  | 'month'
  | 'password'
  | 'color'
  | 'tree-select2'
  className?: string
  min?: string | number
  max?: string | number
  rows?: string
  cols?: string
  style?: React.CSSProperties
  maxLength?: string
  color?: any
  onChangeColor?(
    color: any,
    e: any,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): any
  onChangeFile?(
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): any
  onClearFile?(setFieldValue: any, values: any, arrayInput: any): any,
  onChangeTree?(
    setFieldValue: any,
    values: any,
    arrayInput: any,
    currentNode: any,
    selectedNodes: any
  ): void
  defaultValueTree?: any[]
  onBlur?(
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): void
  onChange?(
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any,
    values: any,
    arrayInput: any,
    rowsGridProps: any,

  ): void
  onInput?(
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): void
  onClick?(
    props: propsInterfaceFormGroupInput,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): void
  onKeyUp?(
    props: propsInterfaceFormGroupInput,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): void
  onClickLabel?(
    props: propsInterfaceFormGroupInput,
    setFieldValue: any,
    values: any,
    arrayInput: any
  ): void
  advanceOptions?: autocompleteDTO
  key?: string
  readonly?: boolean
  readonlyCheckbox?: boolean
  disabled?: boolean
  disabledSelect?: boolean
  disabledCheckbox?: boolean
  isSwitch?: boolean
  columInput?: 1 | 2 | 3 | 4 | 5 | 6
  hideInput?: boolean
  arrayInput?: propsInterfaceFormGroupInput[] | undefined
  formikProps?: FormikProps<any>
  rowsGridProps?: any,
}
export { FormGroupInput }
